import {Routes, Route, BrowserRouter, Navigate, Outlet} from "react-router-dom";
import RecipeList from "./pages/RecipeList";
import RecipeDetailPage from "./pages/RecipeDetail";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import GoogleAuthCallback from "./pages/GoogleAuthCallback";
import FacebookAuthCallback from "./pages/FacebookAuthCallback";
import KrogerRetailerCallback from "./pages/KrogerRetailerCallback";
import "./App.css";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import RecipeCreatePage from "./pages/RecipeCreatePage";
import Feed from "./pages/Feed";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import CartPage from "./pages/CartPage";
import MealPlannerPage from "./pages/MealPlannerPage";
import PantryPage from "./pages/PantryPage";
import ScanCapture from "./pages/ScanCapture";
import useDarkMode from "./hooks/useDarkMode";
import { useAuth } from "./context/AuthContext";


function AppLayout() {
  useDarkMode();
  const { currentUser } = useAuth();
  const isLoggedIn = !!currentUser;

  return (
    <div className="h-screen flex flex-col dark:bg-gray-900">
      {isLoggedIn && <Header />}
      <div className="flex flex-1 overflow-hidden">
        {isLoggedIn && <Sidebar />}
        <main className="flex-1 overflow-y-auto dark:bg-gray-900">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
        <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
        <Route path="/auth/facebook/callback" element={<FacebookAuthCallback />} />
        <Route path="/auth/kroger/callback" element={<KrogerRetailerCallback />} />
        <Route path="/scan/:token" element={<ScanCapture />} />

        <Route element={<AppLayout />}>
          <Route
            path="/recipes"
            element={<PrivateRoute><RecipeList /></PrivateRoute>}
          />
          <Route
            path="/recipes/create"
            element={<PrivateRoute><RecipeCreatePage /></PrivateRoute>}
          />
          <Route
            path="/recipes/:id"
            element={<PrivateRoute><RecipeDetailPage /></PrivateRoute>}
          />
          <Route
            path="/profile"
            element={<PrivateRoute><Profile /></PrivateRoute>}
          />
          <Route
            path="/profile/:id"
            element={<PrivateRoute><Profile /></PrivateRoute>}
          />
          <Route
            path="/settings"
            element={<PrivateRoute><Settings /></PrivateRoute>}
          />
          <Route
            path="/cart"
            element={<PrivateRoute><CartPage /></PrivateRoute>}
          />
          <Route
            path="/feed"
            element={<PrivateRoute><Feed /></PrivateRoute>}
          />
          <Route
            path="/meal-planner"
            element={<PrivateRoute><MealPlannerPage /></PrivateRoute>}
          />
          <Route
            path="/pantry"
            element={<PrivateRoute><PantryPage /></PrivateRoute>}
          />
        </Route>

        <Route path="*" element={<Navigate to={localStorage.getItem("accessToken") ? "/recipes" : "/login"} replace />} />
      </Routes>
    </BrowserRouter>
  );
}



export default App;
